import DynamicZipcodeMap from "./DynamicZipcodeMap";

export default DynamicZipcodeMap;